module.exports = __webpack_public_path__ + "static/img/anxun33.6be0a0b2.png";